// extracted by mini-css-extract-plugin
module.exports = {"warning":"Warning_warning__H6M-4"};